import { AnyToken } from 'src/common/types/models/Tokens'
import { areAddressesEqual } from 'src/common/utils/web3/areAddressesEqual'
import { isGoldToken, isSecurityToken, matchesSearch } from './utils'

/**
 * Filters tokens by group type (RWAs or Crypto).
 */
export const filterByGroup = (
  tokens: AnyToken[],
  group: string,
  investAssets: AnyToken[]
): AnyToken[] => {
  switch (group) {
    case 'RWAs':
      return tokens.filter(token => isSecurityToken(token, investAssets))
    case 'Crypto':
      return tokens.filter(token => !isSecurityToken(token, investAssets))
    case 'Gold':
      return tokens.filter(isGoldToken)
    default:
      return tokens
  }
}

/**
 * Filters tokens based on exclusion and search criteria.
 */
export const filterByCriteria = (
  tokens: AnyToken[],
  exclude: AnyToken | undefined,
  debouncedSearch: string
): AnyToken[] => {
  return tokens
    .filter(
      token =>
        !exclude ||
        !areAddressesEqual(token.contractAddress, exclude.contractAddress)
    )
    .filter(token => matchesSearch(token, debouncedSearch))
}
